import type { PortfolioData } from '../domain/portfolio.types';

export function Blog({ data }: { data: PortfolioData }) {
  return (
    <section className="section" id="blog">
      <div className="container">
        <div className="reveal" style={{ marginBottom: 56, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 20 }}>
          <div>
            <div className="section-tag">07 · Log</div>
            <h2 className="section-title">
              Field <span className="alt">notes</span>.
            </h2>
            <p className="section-sub">Slow writing about craft, code, and the tension between them.</p>
          </div>
          <a className="btn" href={data.contact.socials.find((s) => s.k === 'MD')?.url || '#'} target="_blank" rel="noopener noreferrer">All posts →</a>
        </div>
        <div className="blog-grid">
          {data.blog.map((b, i) => (
            <a className="blog-card reveal" href={b.url || data.contact.socials.find((s) => s.k === 'MD')?.url || '#'} target="_blank" rel="noopener noreferrer" key={i} style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="date">
                <span>{b.date}</span>
                <span className="read">{b.read}</span>
              </div>
              <h3 className="ttl">{b.ttl}</h3>
              <p className="ex">{b.ex}</p>
              <div className="more">READ ENTRY <span>→</span></div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
